var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v(_vm._s(_vm.location))]),(_vm.table && _vm.table.length === 0)?_c('div',[_c('p',[_vm._v("\n      No Data for selected period\n    ")])]):(_vm.isLoading === true)?_c('div',[_c('p',[_vm._v("\n      Loading...\n    ")])]):(!_vm.isLoading && _vm.table && _vm.table.length !== 0)?_c('div',[_c('BasicTableComponent',{attrs:{"list":_vm.table,"tableClass":"table2excel","tableID":_vm.location,"formatters":{
        'date' : ['d', 'ddd MM/DD/YY'], 
        'Interac_#' :  ['n', '0,0'],
        'VISA_#' :  ['n', '0,0'],
        'M/C_#' :  ['n', '0,0'],
        'Amex_#' :  ['n', '0,0'],
        'Discovery_#' :  ['n', '0,0'],
      },"titles":{
        'M/C_amount' : 'M/C Amount', 
        'M/C_#' : 'M/C #', 
      }}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }